import { combineReducers } from 'redux';

import {
  RECEIVE_NAVI,
  RECEIVE_PAGES,
  RECEIVE_DATE,
  RECEIVE_HOURS,
  SWITCH_LANG,
  RECEIVE_FRONTPAGE,
  RECEIVE_INSTAGRAM,
  RECEIVE_MENUS,
  RECEIVE_CONTACT,
  RECEIVE_BLOGS,
  RECEIVE_COLLECTIONS,
  RECEIVE_RESERVATION_INFO
} from './actions';

function storeState(key, state) {
  localStorage.setItem(`bw_restaurants_${key}`, JSON.stringify(state));
};

function getStoredState(key) {
  return JSON.parse(localStorage.getItem(`bw_restaurants_${key}`));
};

function navi(state = null, action) {
  if (action.type === RECEIVE_NAVI) {
    return action.items;
  }

  return state;
}

function pages(state = {}, action) {
  if (action.type === RECEIVE_PAGES) {
    const items = Object.assign({}, state, {
      [action.item.slug]: action.item
    });

    return items;
  }

  return state;
}

function date(state = new Date(), action) {
  if (action.type === RECEIVE_DATE) {
    return new Date(action.date);
  }

  return state;
}

// open hour text
const reservationTexts = (state = null, action) => {
  switch (action.type) {
    case RECEIVE_RESERVATION_INFO:
      return action.texts
    default:
      return state;
  }
}

// open hour text
const hours = (state = "", action) => {
  switch (action.type) {
    case RECEIVE_HOURS:
      return action.hoursText
    default:
      return state;
  }
}

// the language of page
const lang = (state = getStoredState('lang') || "fi", action) => {
  switch (action.type) {
    case SWITCH_LANG:
      const lang = state === "fi" ? "en" : "fi";
      storeState('lang', lang);
      return lang;
    default:
      return state;
  }
}

// the frontpage
const front = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_FRONTPAGE:
      return action.data;
    default:
      return state;
  }
}

// the instagrams
const instagrams = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_INSTAGRAM:
      return action.data;
    default:
      return state;
  }
}

// the menus
const menus = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_MENUS:
      return action.data;
    default:
      return state;
  }
}

// all products
const products = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_MENUS:
      let menus = action.data;
      let products = [];
      let getProduct = (obj) => {
          if(obj.sys.contentType) {
            switch(obj.sys.contentType.sys.id)
            {
                case "category":
                    if(obj.fields.children)
                    {
                        obj.fields.children.forEach(getProduct);
                    }
                    break;
                case "product":
                    products.push(obj);
                    break;
                default:
                    break;
            }
          }
      };
      menus.forEach((menu)=>{
          if (menu.fields.children)
          {
              menu.fields.children.forEach(getProduct);
          }
      });
      return products;
    default:
      return state;
  }
}

// product group, category
const categories = (state = [], action) => {
  switch (action.type) {
    case RECEIVE_MENUS:
      let menus = action.data;
      let categories = [];
      let getCategory = (obj) => {
          if(obj.sys.contentType) {
            switch(obj.sys.contentType.sys.id)
            {
                case "category":
                    categories.push(obj);
                    if(obj.fields.children)
                    {
                        obj.fields.children.forEach(getCategory);
                    }
                    break;
                default:
                    break;
            }
          }
      };
      menus.forEach((menu)=>{
          if (menu.fields.children)
          {
              menu.fields.children.forEach(getCategory);
          }
      });
      return categories;
    default:
      return state;
  }
}

// contact page
const contact = (state={},action) => {
  switch(action.type) {
    case RECEIVE_CONTACT:
      return action.data;
    default:
      return state;
  }
}

// blogs page
const blogs = (state=[],action) => {
  switch (action.type) {
    case RECEIVE_BLOGS:
      return action.data;
    default:
      return state;
  }
}

// collections
const collections = (state=null,action) => {
  switch (action.type) {
    case RECEIVE_COLLECTIONS:
      return action.collection;
    default:
      return state;
  }
}

export default combineReducers({
  navi,
  pages,
  date,
  hours,
  lang,
  front,
  instagrams,
  menus,
  products,
  categories,
  contact,
  blogs,
  collections,
  reservationTexts
})



// WEBPACK FOOTER //
// ./src/redux/reducers.js